// Generated from the booking contract; do not edit by hand.
export const BOOKING_CONTRACT_VALUES = {
  defaults: {
    policy: {
      capacity: 50,
      dailyLimit: 2,
      weeklyLimit: 4,
      reminderOffsetMinutes: 15,
      responseWindowMinutes: 5,
    },
    slotDurationMinutes: 60,
  },
  limits: {
    capacity: {
      min: 1,
      max: 1000,
    },
    dailyLimit: {
      min: 0,
    },
    weeklyLimit: {
      min: 0,
    },
    reminderOffsetMinutes: {
      min: 0,
      max: 1440,
    },
    responseWindowMinutes: {
      min: 1,
      max: 1440,
    },
    durationMinutes: {
      min: 1,
      max: 1440,
    },
    rangeDays: {
      max: 31,
    },
    pageLimit: {
      min: 1,
      max: 100,
      default: 100,
    },
    reasonLength: {
      min: 1,
      max: 500,
    },
    timezoneLength: {
      min: 1,
      max: 100,
    },
  },
  links: {
    reminderPagePath: '/user/bookings/reminders/',
  },
  refusalCodes: [
    'slot_full',
    'daily_limit',
    'weekly_limit',
    'slot_cancelled',
    'slot_ended',
    'booking_in_use',
    'no_booking',
    'user_not_in_org',
    'booking_not_active',
    'timezone_missing',
    'config_conflict',
    'stale_slot',
    'smtp_not_configured',
    'practice_in_progress',
    'seats_held',
    'booking_disabled',
    'org_inactive',
    'not_a_learner',
    'slot_active',
    'reminder_not_actionable',
    'not_owner',
    'queue_not_ready',
  ],
  bookingStatuses: ['reserved', 'completed', 'cancelled', 'released', 'admin_cancelled'],
  practiceRecencySeconds: 60,
  realtimeEvents: [
    {
      name: 'booking:access-revoked',
      payload: ['reason', 'sessionUuid', 'bookingUuid'],
      reasons: ['force_released', 'membership_changed', 'deactivated'],
    },
    {
      name: 'booking:access-changed',
      payload: ['sessionUuid', 'bookingUuid', 'accessEndAt'],
      reasons: [],
    },
  ],
} as const;
